// CURSOR
const cursor=document.getElementById('cursor'),ring=document.getElementById('cursorRing');
if(cursor&&ring){
  let mx=0,my=0,rx=0,ry=0;
  document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;});
  (function loop(){rx+=(mx-rx)*.15;ry+=(my-ry)*.15;cursor.style.left=mx+'px';cursor.style.top=my+'px';ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(loop);})();
}

// NAV SCROLL
const nav=document.getElementById('mainNav');
if(nav){window.addEventListener('scroll',()=>nav.classList.toggle('scrolled',scrollY>60));}

// COUNTDOWN bis Monatsende
function tick(){
  const now=new Date(),end=new Date(now.getFullYear(),now.getMonth()+1,1),s=Math.floor((end-now)/1000);
  const el=id=>document.getElementById(id);
  if(el('cd-days')) el('cd-days').textContent=String(Math.floor(s/86400)).padStart(2,'0');
  if(el('cd-hours')) el('cd-hours').textContent=String(Math.floor(s%86400/3600)).padStart(2,'0');
  if(el('cd-mins')) el('cd-mins').textContent=String(Math.floor(s%3600/60)).padStart(2,'0');
  if(el('cd-secs')) el('cd-secs').textContent=String(s%60).padStart(2,'0');
}
tick();setInterval(tick,1000);

// HOTSPOTS
document.querySelectorAll('.hotspot').forEach(h=>{
  h.addEventListener('click',e=>{
    e.stopPropagation();
    const a=h.classList.contains('active');
    document.querySelectorAll('.hotspot').forEach(x=>x.classList.remove('active'));
    if(!a)h.classList.add('active');
  });
});
document.addEventListener('click',()=>document.querySelectorAll('.hotspot').forEach(h=>h.classList.remove('active')));

// SPRACHE DROPDOWN
const langWrapper=document.getElementById('langWrapper');
const langBtn=document.getElementById('langBtn');
if(langBtn&&langWrapper){
  langBtn.addEventListener('click',e=>{
    e.stopPropagation();
    const aw=document.getElementById('accountWrapper');
    if(aw)aw.classList.remove('open');
    langWrapper.classList.toggle('open');
  });
  document.querySelectorAll('.lang-option').forEach(opt=>{
    opt.addEventListener('click',e=>{
      e.preventDefault();e.stopPropagation();
      document.querySelectorAll('.lang-option').forEach(o=>o.classList.remove('active'));
      opt.classList.add('active');
      langWrapper.classList.remove('open');
    });
  });
}

// ACCOUNT DROPDOWN
const accountWrapper=document.getElementById('accountWrapper');
const accountBtn=document.getElementById('accountBtn');
if(accountBtn&&accountWrapper){
  accountBtn.addEventListener('click',e=>{
    e.stopPropagation();
    if(langWrapper)langWrapper.classList.remove('open');
    accountWrapper.classList.toggle('open');
  });
}

// KLICK AUSSERHALB schliesst Dropdowns
document.addEventListener('click',()=>{
  if(langWrapper)langWrapper.classList.remove('open');
  if(accountWrapper)accountWrapper.classList.remove('open');
});

// SCROLL REVEAL
const obs=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('visible');}),{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>obs.observe(el));

// SMOOTH SCROLL
document.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{
  const t=document.querySelector(a.getAttribute('href'));
  if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});}
}));
